import { useState } from 'react';
import { OwnerGate } from '../../components/OwnerGate';
import { managerApi } from '../../lib/api';
import { errorMessage } from '../../components/ErrorModalBody';
import documentacao from '../../content/documentacao.md?raw';

function BackupCard({ senha }: { senha: string }) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  async function baixarBackup() {
    setBusy(true);
    setError('');
    try {
      const backup = await managerApi.exportBackup(senha);
      const blob = new Blob([JSON.stringify(backup, null, 2)], { type: 'application/json' });
      const url = URL.createObjectURL(blob);
      const d = new Date();
      const stamp = `${String(d.getDate()).padStart(2, '0')}${String(d.getMonth() + 1).padStart(2, '0')}${d.getFullYear()}_${String(d.getHours()).padStart(2, '0')}${String(d.getMinutes()).padStart(2, '0')}`;
      const a = document.createElement('a');
      a.href = url; a.download = `backup_coala_${stamp}.json`;
      document.body.appendChild(a); a.click(); document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } catch (err) {
      setError(errorMessage(err));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="card">
      <h2>Backup dos dados</h2>
      <p className="hint">
        Baixa um arquivo .json com todos os dados do projeto (funcionários, pontos, alimentação, recebimentos,
        documentos e assinaturas, consentimentos, histórico de notificações e de troca de PIN — sem senhas).
        As fotos/selfies ficam guardadas no armazenamento do Supabase e não vêm dentro deste arquivo (o backup
        delas depende do plano do Supabase, é um assunto separado do backup de dados).
      </p>
      {error && <div className="err">{error}</div>}
      <button className="btn btn-primary btn-block" disabled={busy} onClick={baixarBackup}>Baixar backup (.json)</button>
    </div>
  );
}

export function DocumentacaoTab() {
  return (
    <OwnerGate>
      {(senha) => (
        <>
          <BackupCard senha={senha} />
          <div className="card">
            <h2>Documentação do sistema</h2>
            <p className="hint">Esse texto é atualizado sempre que o sistema ganha novos recursos.</p>
            <div className="doc-text" style={{ maxHeight: 'none', fontFamily: "'IBM Plex Mono', monospace", fontSize: 12.5 }}>{documentacao}</div>
          </div>
        </>
      )}
    </OwnerGate>
  );
}
